import { createAuthClient } from 'better-auth/react'

/** Same origin: the API is served beside the client in production and proxied in dev. */
export const authClient = createAuthClient({ basePath: '/api/auth' })

/** A relative in-app path, or "/" — never an absolute URL somebody pasted into ?next=. */
export function sanitizeNext(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/'
  return value
}
